import { ServiceEntryComponent } from "@/routes/processes/[processId]/qpm/calculations/[calculationId]/_components/maintenance-entry-component";
import {
  FlyExterminatorMaintenanceMonitorViewDTO,
  MaintenancePriceList,
} from "@/services/backend/qpm/calculations/types/calculation";

export type ServicePriceListComponentProps = {
  calculationId: string;
  maintenancePriceList?: MaintenancePriceList;
  monitors:
    Record<string, FlyExterminatorMaintenanceMonitorViewDTO> | undefined;
};

export function ServicePriceListComponent({
  calculationId,
  maintenancePriceList,
  monitors,
}: ServicePriceListComponentProps) {
  return (
    maintenancePriceList &&
    maintenancePriceList.positions.map((maintenancePrice) => (
      <ServiceEntryComponent
        key={maintenancePrice.monitorId}
        monitor={monitors?.[maintenancePrice.monitorId]}
        calculationId={calculationId}
        maintenancePrice={maintenancePrice}
      />
    ))
  );
}
